export default __webpack_public_path__ + "static/media/arrow-left-circle.04c81e07.svg";